<template>
  <o-view>
    <o-view>
      <o-nav-bar title="Mobib Card" :has-back-button="true" />
      <o-block-list title="My Mobib Cards">
        <o-mobib-card
          label="Simon's Mobib Card"
          serialNumber="123456"
          cardNumber="1234 5678 9123"
        />
        <o-mobib-card
          label="Second Card"
          serialNumber="123456"
          cardNumber="1234 5678 9123"
        />
      </o-block-list>
    </o-view>
    <o-pay-button label="Save" @click="goBack" />
  </o-view>
</template>

<script>
import OMobibCard from '@/components/OMobibCard.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  components: {
    OMobibCard,
    OPayButton
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
